export default __webpack_public_path__ + "static/media/maestro.c32c4565.svg";